import { TransitionsComponent } from './transitions/transitions.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { IonicModule } from '@ionic/angular';
import { PageBaseComponent } from './page-base/page-base.component';
import { QuestionBaseComponent } from './question-base/question-base.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ButtonComponent,
    PageBaseComponent,
    QuestionBaseComponent,
    TransitionsComponent,
    FooterComponent,
  ],
  imports: [CommonModule, IonicModule, FormsModule],
  exports: [
    ButtonComponent,
    PageBaseComponent,
    QuestionBaseComponent,
    TransitionsComponent,
    FooterComponent,
  ],
})
export class ComponentsModule {}
